module.exports = __webpack_public_path__ + "img/img_box_unopened.a65a144d.png";